import { RootState } from '../root.reducers';
import { PeriodicAudit } from './periodicAudit.types';

export const getPeriodicAuditList = (state: RootState): PeriodicAudit[] =>
  state.periodicAudit.entities;

export const getPeriodicAudit = (state: RootState): PeriodicAudit | null =>
  state.periodicAudit.single;

export const getSelectedPeriodicAudit = (state: RootState): PeriodicAudit[] =>
  state.periodicAudit.selected;

export const getPeriodicAuditCreatedId = (state: RootState): string | null =>
  state.periodicAudit.createdId;

export const isPeriodicAuditCreatePopupOpen = (state: RootState): boolean =>
  state.periodicAudit.ui.isCreatePopupOpen;

export const isPeriodicAuditLoading = (state: RootState): boolean =>
  state.periodicAudit.ui.isLoading;
